export default __webpack_public_path__ + "static/media/inProgress.0d8ace89.svg";